import React, { useState, useEffect } from 'react';
import { includes } from 'lodash';
import 'styles/layouts/Hero.scss';
import UserStatusNotification from 'components/UserStatusNotification';
import SMSOptInAlert from '../components/SMSOptInAlert';
interface HeroProps {
    hero_title: string;
    hero_description: string;
    images: string[];
    styles: string;
    background: string;
    children?: React.ReactNode;
}

const Hero: React.FC<HeroProps> = ({ hero_title, hero_description, images, styles, background, children }) => {
    const [image, setImage] = useState(images[3]);

    const getImage = () => {
        if (typeof window === 'undefined') {
            setImage(images[0]); // xxs
            return images[0];
        }

        switch (true) {
            case window.innerWidth <= 320:
                setImage(images[0]); // xxs
                return images[0];
            case window.innerWidth <= 480:
                setImage(images[1]); // xs
                return images[1];
            case window.innerWidth <= 768:
                setImage(images[2]); // sm
                return images[2];
            case window.innerWidth <= 992:
                setImage(images[3]); // md
                return images[3];
            default: // 1200 and higher
                setImage(images[4]); // lg
                return images[4];
        }
    };

    useEffect(() => {
        getImage();
        window.addEventListener('resize', getImage);

        return () => {
            window.removeEventListener('resize', getImage);
        };
    }, []);

    if (!includes(styles, 'home-hero')) {
        return (
            <div className={styles} style={{ background }}>
                <SMSOptInAlert />
                <UserStatusNotification with_container={false} for_dashboard={null} />
                <div className="sub-container">
                    <h1 className="hero-title">{hero_title}</h1>
                    <img src={image} alt={hero_description} className="hero-image" />
                </div>
            </div>
        );
    }

    return (
        <div className={styles} style={{ background }}>
            <SMSOptInAlert />
            <UserStatusNotification with_container={false} for_dashboard={null} />
            <div className="sub-container">
                <h1 className="hero-title">{hero_title}</h1>
                <div className="hero-description">{hero_description}</div>
                <div className="hero-child">{children}</div>
                <img src={image} alt={hero_description} className="hero-image" />
            </div>
        </div>
    );
};

export default Hero;
